import React, { useEffect, useRef, useState } from 'react';
import {
  Wrap,
  Header,
  CloseButton,
  SubmitButton,
  InputWrap,
  Info,
  Input
} from './styled';
import clsx from 'clsx';
import useUsersStore from '../../../../../hooks/useUsersStore';
import useCheckLogin from '../../../../../hooks/useCheckLogin';
import useModalStore from '../../../../../hooks/useModalStore';
import { useHistory } from 'react-router-dom';
import { Url } from '../../../../../common/constants/environment';

const SuperChatInput = ({
  viewChatInput,
  setViewChatInput,
  postCheerComment
}) => {
  const inputRef = useRef(null);
  const { isCheckLogin } = useCheckLogin();
  const modal = useModalStore();
  const history = useHistory();
  const userStore = useUsersStore();
  const { level, profile_image_path, nick, certify, is_admin } = userStore.data;

  const [text, setText] = useState('');

  useEffect(() => {
    if (viewChatInput) {
      inputRef.current.focus();
    }
  }, [viewChatInput]);

  const onClickSubmit = () => {
    if (text.length === 0) {
      alert('메세지를 입력하세요.');
      return;
    }

    if (!isCheckLogin) {
      modal.openConfirmModal({
        message: '로그인 후 사용이 가능 합니다. 로그인 하시겠습니까?',
        okCallback: () => history.push('/auth/login')
      });
      return;
    }

    if (!is_admin) {
      if (!certify.is_phone_certify) {
        modal.openConfirmModal({
          message: '휴대폰 인증 후 사용이 가능 합니다. 인증 하시겠습니까?',
          okCallback: () => history.push('/mypage/info')
        });
        return;
      }
    }

    const param = {
      content: text,
      device: 'WEB_MOBILE',
      messageType: 'POWER_CHAT'
    };
    postCheerComment(param).then((res) => {
      if (res.status === 200) {
        setText('');
        setViewChatInput(false);
      } else {
        modal.openAlertModal({
          message: res.data.message
        });
      }
    });
  };

  const onInputKeyDown = (e) => {
    if (e.keyCode === 13) {
      onClickSubmit();
    }
  };

  return (
    <Wrap view={viewChatInput}>
      <Header>
        <h2>Power Chat 보내기</h2>
        <p>파워챗을 보내면 응원 메뉴 상단에 고정됩니다.</p>
        <CloseButton onClick={() => setViewChatInput(false)} />
      </Header>
      <InputWrap>
        <Info>
          <div className={'profile_img'}>
            <span className={clsx('thumb', `lv${level}`)}>
              <img
                src={
                  profile_image_path
                    ? `${
                        Url.thumb
                      }normal/crop/112x112${profile_image_path.replace(
                        'data/',
                        ''
                      )}`
                    : '/images/thumb_user_def.png'
                }
                onError={(event) => {
                  event.target.src = '/images/thumb_user_def.png';
                }}
              />
              <svg
                className="border"
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 36 36"
                enableBackground="new 0 0 36 36"
                xmlSpace="preserve"
              >
                <path d="M18,2c10.9,0,16,5.1,16,16c0,10.9-5.1,16-16,16C7.1,34,2,28.9,2,18C2,7.1,7.1,2,18,2 M18,0C6,0,0,6,0,18c0,12,6,18,18,18c12,0,18-6,18-18C36,6,30,0,18,0L18,0z" />
              </svg>
            </span>
          </div>
          <div className={'info'}>
            <span className={'nick'}>{nick}</span>
            <p>100,000포인트가 소모됩니다.</p>
          </div>
        </Info>
        <Input
          ref={inputRef}
          type={'text'}
          placeholder={'메세지를 입력해 관심을 받아보세요.'}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={onInputKeyDown}
        />
      </InputWrap>
      <SubmitButton isActive={text.length > 0} onClick={onClickSubmit}>
        파워챗 보내기
      </SubmitButton>
    </Wrap>
  );
};

export default SuperChatInput;
